export default "__VITE_ASSET__WUecwYi5__"